import livro from '../../img/livro.png'
import livroHarry from '../../img/livroHarryPotter.jpg'
import livroSenhor from '../../img/livroSenhorDosAneis.png'

export const livros = [
  { nome: 'Liderança em Design', id: 1, src: livro },
  { nome: 'Como fazer amigos?', id: 2, src: livro },
  { nome: 'Como se tornar um verdadeiro programador?', id: 3, src: livro },
  { nome: 'Liderança em Design II', id: 4, src: livro },
  { nome: 'Como fazer inimigos?', id: 5, src: livro },
  { nome: 'A verdadeira verdade', id: 6, src: livro },
  { nome: 'Velozes e Furiosos', id: 7, src: livro },
  { nome: 'Harry Potter e a Pedra Filosofal', id: 8, src: livroHarry },
  { nome: 'Harry Potter e a Câmara Secreta', id: 9, src: livroHarry },
  { nome: 'Harry Potter e o Prisioneiro de Azkaban', id: 10, src: livroHarry },
  { nome: 'Harry Potter e o Cálice de Fogo', id: 11, src: livroHarry },
  { nome: 'Harry Potter e a Ordem da Fênix', id: 12, src: livroHarry },
  { nome: 'Orgulho e Preconceito', id: 13, src: livro },
  { nome: '1984', id: 14, src: livro },
  { nome: 'O Grande Gatsby', id: 15, src: livro },
  { nome: 'Moby Dick', id: 16, src: livro },
  { nome: 'O Sol é Para Todos', id: 17, src: livro },
  { nome: 'A Revolução dos Bichos', id: 18, src: livro },
  { nome: 'O Senhor dos Anéis: A Sociedade do Anel', id: 19, src: livroSenhor },
  { nome: 'O Hobbit', id: 20, src: livro },
]
